module.exports = __webpack_public_path__ + "img/enterprise.68e6471.png";